import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/accounts',
    name: 'accounts',
    component: () => import('@/views/restricted/accounts/AccountLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: [
        'ADMIN_ACCOUNT_READ_PERMISSION',
        'ADMIN_ROLE_READ_PERMISSION',
        'ADMIN_HISTORY_ACTION_READ',
        'ADMIN_BILLING_READ_PERMISSION'
      ],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/accounts/create',
    name: 'accountCreate',
    component: () => import('@/views/restricted/accounts/account/AccountCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ACCOUNT_CREATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/accounts/:accountId/edit',
    name: 'accountUpdate',
    component: () => import('@/views/restricted/accounts/account/AccountUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ACCOUNT_UPDATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/accounts/:accountId',
    name: 'accountDetail',
    component: () => import('@/views/restricted/accounts/account/AccountDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ACCOUNT_READ_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/accounts/:accountId/collaborators/create',
    name: 'collaboratorCreate',
    component: () =>
      import('@/views/restricted/accounts/account/collaborator/CollaboratorCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ADD_COLLABORATOR'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/accounts/:accountId/collaborators/:collaboratorId/edit',
    name: 'collaboratorUpdate',
    component: () =>
      import('@/views/restricted/accounts/account/collaborator/CollaboratorUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_UPDATE_COLLABORATOR'],
      menuSelected: 'accounts'
    }
  }
]
